import { useWidgetContext } from '../../WidgetContext';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { track as dashboardTracker, EVENTS
// @ts-expect-error untyped dependency
} from 'dashboard-ui-components/tracking/DashboardUITracker';
import { isIframeWidget, isNoteWidget
// @ts-expect-error untyped dependency
} from 'dashboard-lib/public/report/report-logic';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped dependency
import { useShowDialog } from 'reporting-action-components/dialog/ducks';
import { DELETE_NON_REPORT_WIDGET } from '../../../../constants/dialogTypes';
// @ts-expect-error untyped dependency
import useDeleteNonReportWidgetProblem from 'reporting-action-components/reportingActions/shared/problemHooks/useDeleteNonReportWidgetProblem';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const BaseTrackingObject = {
  actionType: 'edit',
  action: 'delete',
  assetType: 'dashboard',
  interactionSource: 'widget',
  interactionWith: 'asset-action'
};
const DeleteNonReportWidgetAction = () => {
  const {
    dashboard,
    report
  } = useWidgetContext();
  const showDialog = useShowDialog();
  const {
    problem,
    disabledMessage
  } = useDeleteNonReportWidgetProblem({
    dashboard
  });
  const isDisabled = !!problem;
  const handleClickDeleteNonReportWidget = () => {
    if (isNoteWidget(report)) {
      dashboardTracker(EVENTS.clickNoteAction, Object.assign({}, BaseTrackingObject, {
        object: 'note'
      }));
    } else if (isIframeWidget(report)) {
      dashboardTracker(EVENTS.clickIframeAction, Object.assign({}, BaseTrackingObject, {
        object: 'iframe'
      }));
    }
    showDialog({
      dialogType: DELETE_NON_REPORT_WIDGET,
      dialogProps: {
        report
      }
    });
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !problem,
    title: disabledMessage,
    children: /*#__PURE__*/_jsx(Button, {
      use: "tertiary-light",
      size: "extra-small",
      onClick: handleClickDeleteNonReportWidget,
      disabled: isDisabled,
      children: /*#__PURE__*/_jsx(View, {
        inlineSize: "100%",
        textAlign: "left",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "noteWidget.delete.button"
        })
      })
    })
  }, "delete-note-or-iframe");
};
export default DeleteNonReportWidgetAction;